import React, { useEffect, useRef, useState } from "react";
import { Image } from "antd";
import './images.scss';
import { downloadUserReportRequest } from "../../screens/users/states/action";
import { useDispatch } from "react-redux";
import { FileExcelOutlined, FileImageOutlined } from "@ant-design/icons";
import { Notification } from "../../components/notification/notification";
import { GetRequest } from "../../utils/api";
import CustomLoader from "../../components/loader";

interface Props {
  title?: string;
  src: string;
  alt: string;
  type?: string
  URLloaded?: boolean;
  modelOpen?: boolean;
  onPreviewClosed?: any;
}
const ImageComponent: React.FC<Props> = ({
  title,
  src,
  alt,
  type,
  URLloaded = false,
  modelOpen,
  onPreviewClosed = () => { },
}) => {

  const imageUrl = useRef(src);
  const [loading, setLoading] = useState<boolean>(false);
  const [isPreviewVisible, setPreviewVisible] = useState<boolean>(false);
  const dispatch = useDispatch();


  const fetchImage = async () => {
    if (title && type === 'image' && !URLloaded) {
     
      try {

        const response = await GetRequest(src+title,'arraybuffer');

        let blob = new Blob([response], { type: 'image/jpeg' });
        imageUrl.current = URL.createObjectURL(blob);

      } catch (error) {
        Notification("error", "Failed to download Image")
      }
    } 
  };


  const openImage = (ev:any) => {
    ev.stopPropagation();
    setLoading(true);

    fetchImage().then(() => {
      setLoading(false);
      setPreviewVisible(!isPreviewVisible);
    })

  }

  useEffect(() => {
    
    if (modelOpen) {
      setPreviewVisible(modelOpen)
    }
  }, []);
  return (
    <>
      {type === 'image' && (
        <>
          {/* IF title is not present and URL is not already loaded - API call to get image will fail - hence do not show the icon */}
         { ((title && title.length > 0) || URLloaded) && <>{loading ?  <CustomLoader size="sm"></CustomLoader> :  <FileImageOutlined className="text-2xl m-2" onClick={(ev) => openImage(ev)} rev={undefined} />} </>  }   
          
          {isPreviewVisible && (
            <Image
              width={50}
              alt={alt}
              preview={{
                visible: isPreviewVisible,
                onVisibleChange: (visible) => { setPreviewVisible(visible); onPreviewClosed() },
              }}
              src={imageUrl.current} />
          )}
        </>
      )}

      {type === "download" && (title &&
        <div onClick={(ev) => { ev.stopPropagation(); dispatch(downloadUserReportRequest(src + title)); }}>
          <FileExcelOutlined width={200} className="document-icon text-2xl m-2" rev={undefined} />
        </div>
      )}
    </>
  );
};

export default ImageComponent
